import { gql } from '@apollo/client';

const MUTATION_UPDATE_CONSUMABLES = gql`
    mutation updateCartAccessories($cartId: String!, $accessories: String!) {
        updateCartAccessories(input: { cart_id: $cartId, accessories: $accessories }) {
            message
        }
    }
`;

export default MUTATION_UPDATE_CONSUMABLES;